// extracted by mini-css-extract-plugin
export default {"projectIssueDetailsStatus":"bMvdMScKci29qrkue2z0","globalIssueDetailsStatus":"KylLHAOKakEywFkQDISl","userEmail":"usohnDwCVNg3Ht6nZxxc"};